module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-agency-tree"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "popper-class": _vm.popperClass,
      "placement": "bottom-start",
      "visible-arrow": false,
      "width": _vm.width,
      "trigger": "click"
    },
    on: {
      "show": _vm.handleShow,
      "hide": _vm.handleHideMore
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('AgencyTreeCore', _vm._g(_vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore),
      expression: "!showMore"
    }],
    ref: "treeCore",
    attrs: {
      "treeData": _vm.coreData,
      "isCRMUser": _vm.isCRMUser,
      "filter-node-method": _vm.filterNodeMethod,
      "checkable": _vm.checkable
    },
    on: {
      "showMore": _vm.handleShowMore,
      "checkAgencyLeaves": _vm.checkAgencyLeaves,
      "nodeClick": _vm.handleNodeClick
    }
  }, 'AgencyTreeCore', _vm.$attrs, false), _vm.$listeners)), _vm._v(" "), _c('AgencyTreeDetail', _vm._g(_vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    ref: "treeDetail",
    attrs: {
      "treeData": _vm.detailData,
      "isCRMUser": _vm.isCRMUser,
      "checkable": _vm.checkable
    },
    on: {
      "confirm": _vm.handleConfirm,
      "close": _vm.handleClose
    }
  }, 'AgencyTreeDetail', _vm.$attrs, false), _vm.$listeners))], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "trigger-input",
    attrs: {
      "placeholder": "请选择门店",
      "suffix-icon": "el-icon-caret-bottom",
      "readonly": ""
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-714ef650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/AgencyTree/AgencyTree.vue
// module id = 187
// module chunks = 0